import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('integrationname_organis_onnected_to_approvalmax'),
    description: defineMessage('integrationname_org_is__nkcontact_ussupportlink'),
    cancelButtonText: defineMessage('cancel'),
};
